<script lang="ts">
  import Stack from "../../components/Stack.svelte";
  import TextNew from "../../components/TextNew.svelte";
  import Checkmark from "../../components/icons/Checkmark.svelte";

  export let subtitle: string;
  export let additional: string | undefined = undefined;
</script>

<div class="product-card">
  <Stack vertical spacing="x-small">
    <TextNew size="s">REKKI Insights Premium</TextNew>
    <Stack horizontal alignItems="flex-end" spacing="x-small">
      <TextNew size="xs" --rk-text-color="var(--rk-text-success)" weight="medium"
        >{subtitle}</TextNew
      >
      {#if additional}
        <div class="additional">
          <TextNew size="xxs" --rk-text-color="var(--rk-text-transparency-dark)"
            >{additional}</TextNew
          >
        </div>
      {/if}
    </Stack>
  </Stack>
  <div class="check-container">
    <Checkmark />
  </div>
</div>

<style>
  .product-card {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-radius: 12px;
    border: solid 1px var(--rekki-neutral-01);
  }

  .check-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-color: var(--rekki-dark);
  }

  .additional {
    text-decoration: line-through;
    padding-left: 4px;
  }
</style>
